export default interface DotCommentVersion {
  vid: string;
  versionIndex: number;
  state: DotCommentVersionState;
  versionURL: string;
}

export enum DotCommentVersionState {
  Deleted = "deleted",
  Outdated = "outdated",
  Current = "current"
}

export function getDotCommentVersionName(versionIndex: number, state: DotCommentVersionState): string {
    switch (state) {
        case DotCommentVersionState.Deleted:
            return "v?";
        case DotCommentVersionState.Outdated:
            return `v${versionIndex}↗`;
        case DotCommentVersionState.Current:
            return `v${versionIndex}`;
        default:
            return "";
    }
}

export function getDotCommentVersionTooltip(versionIndex: number, state: DotCommentVersionState): string {
    switch (state) {
        case DotCommentVersionState.Deleted:
            return "Added on a deleted version";
        case DotCommentVersionState.Outdated:
            return `Added back in v${versionIndex}`;
        case DotCommentVersionState.Current:
            return "Added on current version";
        default:
            return "";
    }
}
